function initPageContentLinkEvents() {
    var onClick = function( event ) {
        if ( !event.target || !( event.target instanceof HTMLAnchorElement ) ) {
            return;
        }

        let el = event.target;

        let hasHref = el.hasAttribute( 'href' );

        if ( !hasHref && !el.dataset.altHref ) {
            return;
        }

        let isLocationAnchor = el.matches( '[data-action="page-content-link"]' );
        let isContentLink = el.matches( '.location-info a' );

        if ( !isLocationAnchor && !isContentLink ) {
            return;
        }
    };

    document.addEventListener( 'click', onClick, false );
}

export default initPageContentLinkEvents;
